// Web shim for react-native-skeleton-placeholder
import React from 'react';
import { View, ViewStyle, Animated, DimensionValue } from 'react-native';

export interface SkeletonPlaceholderProps {
  children?: React.ReactNode;
  backgroundColor?: string;
  highlightColor?: string;
  speed?: number;
  direction?: 'leftRight' | 'rightLeft' | 'topBottom' | 'bottomTop';
  enabled?: boolean;
  borderRadius?: number;
}

export interface SkeletonPlaceholderItemProps {
  width?: DimensionValue;
  height?: number;
  borderRadius?: number;
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  marginHorizontal?: number;
  marginVertical?: number;
  style?: ViewStyle;
  children?: React.ReactNode;
}

const SkeletonPlaceholder: React.FC<SkeletonPlaceholderProps> = ({
  children,
  backgroundColor = '#E1E9EE',
  highlightColor = '#F2F8FC',
  speed = 1200,
  direction = 'rightLeft',
  enabled = true,
  borderRadius = 4,
}) => {
  const animatedValue = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    if (enabled) {
      const animation = Animated.loop(
        Animated.sequence([
          Animated.timing(animatedValue, {
            toValue: 1,
            duration: speed,
            useNativeDriver: false,
          }),
          Animated.timing(animatedValue, {
            toValue: 0,
            duration: speed,
            useNativeDriver: false,
          }),
        ])
      );
      animation.start();
      return () => animation.stop();
    }
  }, [enabled, speed, animatedValue]);

  const opacity = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0.3, 1],
  });

  return (
    <View style={{ backgroundColor, borderRadius }}>
      {enabled ? (
        <Animated.View style={{ opacity }}>
          {children}
        </Animated.View>
      ) : (
        children
      )}
    </View>
  );
};

export const SkeletonPlaceholderItem: React.FC<SkeletonPlaceholderItemProps> = ({
  width,
  height = 20,
  borderRadius = 4,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  marginHorizontal,
  marginVertical,
  style,
  children,
}) => {
  return (
    <View
      style={[
        {
          width: width||'100%',
          height,
          borderRadius,
          backgroundColor: '#E1E9EE',
          marginTop,
          marginBottom,
          marginLeft,
          marginRight,
          marginHorizontal,
          marginVertical,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
};

// 默认导出
export default SkeletonPlaceholder;
